import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import MissionVision from './components/MissionVision';
import GlobalPresence from './components/GlobalPresence';
import Leadership from './components/Leadership';
import Milestones from './components/Milestones';

export default function AboutPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://trackverse.com';

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://track-verse.com';
    document.title = 'À Propos de TrackVerse — Expert Logistique Internationale Depuis 2020 | Ajaccio';
    document.documentElement.lang = 'fr';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Découvrez TrackVerse, fondée par Michael Ashley en 2020 à Ajaccio. Solutions logistiques innovantes dans 50+ pays avec technologie de suivi de pointe, 500+ employés et service client exceptionnel.');
    setMeta('keywords', 'à propos TrackVerse, société logistique Ajaccio, Michael Ashley, expédition mondiale, histoire entreprise, logistique Corse');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); (canonical as HTMLLinkElement).rel = 'canonical'; document.head.appendChild(canonical); }
    (canonical as HTMLLinkElement).href = `${siteUrl}/about`;

    setMeta('og:title', 'À Propos de TrackVerse — Logistique Internationale Depuis Ajaccio', true);
    setMeta('og:description', 'Fondée en 2020 par Michael Ashley à Ajaccio. 50+ pays, 500+ employés, technologie de suivi colis en temps réel.', true);
    setMeta('og:url', `${siteUrl}/about`, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', `${siteUrl}/og-image.jpg`, true);
    setMeta('twitter:title', 'À Propos de TrackVerse — Logistique Internationale');
    setMeta('twitter:description', 'Fondée en 2020 à Ajaccio. 50+ pays, technologie de suivi temps réel.');
    setMeta('twitter:image', `${siteUrl}/og-image.jpg`);

    const aboutPageSchema = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "À Propos de TrackVerse",
      "url": `${siteUrl}/about`,
      "description": "Découvrez la mission, la vision et la présence mondiale de TrackVerse en logistique",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "À Propos", "item": `${siteUrl}/about` }
        ]
      },
      "mainEntity": {
        "@type": "Organization",
        "name": "TrackVerse",
        "foundingDate": "2020",
        "foundingLocation": { "@type": "Place", "name": "Ajaccio, Corse, France" },
        "founder": { "@type": "Person", "name": "Michael Ashley" },
        "numberOfEmployees": { "@type": "QuantitativeValue", "value": "500+" },
        "areaServed": { "@type": "Place", "name": "50+ pays dans le monde" }
      }
    };

    let script = document.querySelector('script[data-schema="about"]');
    if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.setAttribute('data-schema', 'about'); document.head.appendChild(script); }
    script.textContent = JSON.stringify(aboutPageSchema);

    return () => { const s = document.querySelector('script[data-schema="about"]'); if (s) s.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <MissionVision />
      <GlobalPresence />
      <Leadership />
      <Milestones />
      <Footer />
    </div>
  );
}
